<template>           
    <ChannelsGeneral title="SMS" subtitle="The gold standard for customer engagement">
        <template #content>
            <p>
                With Yabbr, SMS isn’t just simple text messaging. It’s a versatile channel for recognition, engagement, and automation. <br><br>
                Send <b>branded blasts</b> from recognisable Alpha Codes (e.g. “GreenCo”) for instant trust, run <b>two-way campaigns</b> with chatbots or agents in real time, and set up fully <b>automated text-in lines</b> that power ongoing workflows.
                <br><v-btn
                class="btn-primary--outline rounded-pill mt-8"
                outlined
                large
                :ripple="false"
                href="/campaigns"
                >
                Campaigns
                    <v-icon>mdi-arrow-right-thin</v-icon>
                </v-btn>
            </p>
        </template>
        <template #img>
            <v-img
        
            src="../assets/img/sms.png"
            alt="SMS conversation"
            class="rounded-xl mx-auto"
            style="box-shadow: 0 0 5px 5px lightgrey;"
            max-width="250px"/>
        </template>
    </ChannelsGeneral>
</template>

<script>
import ChannelsGeneral from './ChannelsGeneral.vue'

export default {
    name: 'ChannelsSMS',
    components: {
    ChannelsGeneral
    }
}
</script>

<style lang="scss">
</style>